import 'remodal'
;(function ($) {
	'use strict'

	// Back button — show if user arrived from the provider listing page.
	var storageKey = 'providerListUrl'
	var $backButton = $('#provider-back-button')
	var listUrl = sessionStorage.getItem(storageKey)

	if (listUrl && $backButton.length) {
		$backButton.show()
		$backButton.on('click', function () {
			window.location.href = listUrl
		})
	} else if ($backButton.length) {
		$backButton.hide()
	}

	// Book Appointment modal.
	var $appointmentModal = $('[data-remodal-id=book-appointment-modal]')
	if ($appointmentModal.length) {
		//var appointment_inst = $appointmentModal.remodal()
		var appointment_inst = $appointmentModal.remodal({ hashTracking: false })
		$(document).on('click', '#book-appointment-modal-button', function () {
			appointment_inst.open()
		})
	}

	// Share modal.
	var $shareModal = $('[data-remodal-id=share-provider-modal]')
	if ($shareModal.length) {
		//var share_inst = $shareModal.remodal()
		var share_inst = $shareModal.remodal({ hashTracking: false })
		$(document).on('click', '#provider-share-button', function () {
			// Populate the URL input before opening.
			$('#profile-url').val(window.location.origin + window.location.pathname + window.location.search)
			share_inst.open()
		})
	}

	// Copy link button.
	$(document).on('click', '#copy-link-button', function () {
		var $btn = $(this)
		var cleanUrl = window.location.origin + window.location.pathname + window.location.search

		if (navigator.clipboard && window.isSecureContext) {
			navigator.clipboard
				.writeText(cleanUrl)
				.then(function () {
					showCopied($btn)
				})
				.catch(function () {
					fallbackCopy(cleanUrl, $btn)
				})
		} else {
			fallbackCopy(cleanUrl, $btn)
		}

		function fallbackCopy(text, $btn) {
			var $temp = $('<input>')
			$('body').append($temp)
			$temp.val(text).select()
			document.execCommand('copy')
			$temp.remove()
			showCopied($btn)
		}

		function showCopied($btn) {
			$btn.text('Link Copied!')
			setTimeout(function () {
				$btn.text('Copy Link')
			}, 2000)
		}
	})
})(jQuery)

/**
 * TabbedContent - Accessible tabbed content component.
 * Handles the About / Education / Reviews / Locations tabs
 * on the Provider detail page.
 */
class TabbedContent {
	constructor(containerSelector) {
		this.container = document.querySelector(containerSelector)
		if (!this.container) return

		this.tabButtons = this.container.querySelectorAll('.location__item__tab-button')
		this.tabPanels = this.container.querySelectorAll('.location__item__tab-panel')

		this.createLiveRegion()
		this.init()
	}

	createLiveRegion() {
		const liveRegion = document.createElement('div')
		liveRegion.id = 'tab-announcements'
		liveRegion.setAttribute('aria-live', 'polite')
		liveRegion.setAttribute('aria-atomic', 'true')
		liveRegion.className = 'sr-only'
		liveRegion.style.cssText = 'position: absolute; left: -10000px; width: 1px; height: 1px; overflow: hidden;'
		document.body.appendChild(liveRegion)
		this.liveRegion = liveRegion
	}

	init() {
		this.tabButtons.forEach(button => {
			button.addEventListener('click', e => this.handleTabClick(e))
		})
		this.container.addEventListener('keydown', e => this.handleKeyNavigation(e))
	}

	handleTabClick(e) {
		const clickedTab = e.target.dataset.tab
		this.switchTab(clickedTab)
		this.updateTabIndex(e.target)
	}

	switchTab(targetTab) {
		this.tabButtons.forEach(btn => {
			btn.classList.remove('active')
			btn.setAttribute('aria-selected', 'false')
			btn.setAttribute('tabindex', '-1')
		})
		this.tabPanels.forEach(panel => {
			panel.classList.remove('active')
			panel.setAttribute('aria-hidden', 'true')
		})

		const targetButton = this.container.querySelector(`[data-tab="${targetTab}"]`)
		const targetPanel = this.container.querySelector(`#${targetTab}`)

		if (targetButton && targetPanel) {
			targetButton.classList.add('active')
			targetButton.setAttribute('aria-selected', 'true')
			targetButton.setAttribute('tabindex', '0')
			targetPanel.classList.add('active')
			targetPanel.setAttribute('aria-hidden', 'false')
			targetPanel.focus()
			this.announceTabChange(targetButton.textContent.trim())
		}
	}

	handleKeyNavigation(e) {
		const focusedElement = document.activeElement
		const isTabButton = focusedElement.classList.contains('location__item__tab-button')
		if (!isTabButton) return

		const currentIndex = Array.from(this.tabButtons).indexOf(focusedElement)
		let newIndex

		switch (e.key) {
			case 'ArrowLeft':
				e.preventDefault()
				newIndex = currentIndex > 0 ? currentIndex - 1 : this.tabButtons.length - 1
				break
			case 'ArrowRight':
				e.preventDefault()
				newIndex = currentIndex < this.tabButtons.length - 1 ? currentIndex + 1 : 0
				break
			case 'Home':
				e.preventDefault()
				newIndex = 0
				break
			case 'End':
				e.preventDefault()
				newIndex = this.tabButtons.length - 1
				break
			case 'Enter':
			case ' ':
				e.preventDefault()
				this.handleTabClick({ target: focusedElement })
				return
			default:
				return
		}

		if (newIndex !== undefined) {
			this.tabButtons[newIndex].focus()
			this.updateTabIndex(this.tabButtons[newIndex])
		}
	}

	updateTabIndex(activeButton) {
		this.tabButtons.forEach(button => {
			button.setAttribute('tabindex', button === activeButton ? '0' : '-1')
		})
	}

	announceTabChange(tabName) {
		if (this.liveRegion) {
			this.liveRegion.textContent = `${tabName} tab selected`
			setTimeout(() => {
				if (this.liveRegion) {
					this.liveRegion.textContent = ''
				}
			}, 1000)
		}
	}
}

// Initialise tabs on DOM ready.
document.addEventListener('DOMContentLoaded', function () {
	const tabContainer = document.querySelector('.provider-tab-group.location__item__tab-container')
	if (tabContainer) {
		new TabbedContent('.provider-tab-group.location__item__tab-container')
	}
})

if (typeof window !== 'undefined') {
	window.TabbedContent = TabbedContent
}
